import React from 'react';
import GasFrontDeskList from './components/GasFrontDeskList'

const GasFrontDesk = () => (
  <React.Suspense fallback={<div>Loading...</div>} >
    <GasFrontDeskList />
  </React.Suspense>
);

export default GasFrontDesk;
